import * as React from "react";
import { useCallback, useState } from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { IsaAllowanceOverviewClient } from "../../../../../../../../Wrap/Api/ProductOverview/PaymentsIn/IsaAllowanceOverview";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { PaymentSource } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { InvestorType } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { TrustDetail } from "../../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { IsaAllowance } from "../../../../../../../../Wrap/Models/Domains/IsaAllowance/IsaAllowance";
import { ProductValuation } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuation";
import { ProductValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { PaymentStatus } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { CashPayment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentFrequencyQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { InstructionType } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { TextAndDots } from "../../../../../../../Shared/Dropdown/TextAndDots";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Action } from "../../../../../../Actions/Action";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { WizardLinkRestriction } from "../../../../Common/Restrictions/WizardLinkRestriction";
import { findHeadAccount } from "../../Common/PortfolioDashboardHelper";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { SelectRegularPaymentPop } from "../../Common/SelectRegularPaymentPop";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CompanyWizardAction } from "../../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { FsaPermission } from "../../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import {
    CompanyFsaPermissionsStore,
    CompanyWizardStore,
} from "../../../../../../../Admin/Company/CompanyWizard/Stores/Variable";
import { useSubscribeToStore } from "../../../../../../../../react-core/Flux/Hooks/useSubscribeToStore";

interface IThreeDotsDropdownProps {
    isAppStoreEnabled: boolean;
    data: ProductValuation | ProductValuationDetailSummary;
    headAccountHierarchyId: string;
    subAccountHierarchyId: string;
    regularPaymentsIn: boolean;
    isWithDrawalRestriction: boolean;
    trustDetail: TrustDetail;
    buttonTitle?: string;
    restrictWithdrawal: () => void; // callback for restricted account to withdrawal, (ISA, PP, NPR)
    prohibitedWithdrawal: () => void; // callback for prohibited account (onshore/offshore bond)
}

export const ThreeDotsDrodpwn = (props: IThreeDotsDropdownProps) => {
    const textLinks = [];
    const item = props.data;
    const {
        isAppStoreEnabled,
        headAccountHierarchyId,
        subAccountHierarchyId,
        regularPaymentsIn,
        isWithDrawalRestriction,
    } = props;
    const [currentYearIsaAllowance, setCurrentYearIsaAllowance] = useState<IsaAllowance>(null);
    const [lastYearIsaAllowance, setLastYearIsaAllowance] = useState<IsaAllowance>(null);
    const [currentYearIsaAllowanceLoading, setCurrentYearUsaAllowanceLoading] = useState<boolean>(false);
    const [lastYearIsaAllowanceLoading, setLastYearUsaAllowanceLoading] = useState<boolean>(false);
    const [showErrorMsg, setShowErrorMsg] = useState<boolean>(false);
    const [multiPaymentType, setMutiPaymentType] = useState<ProcessType>(null);
    const [companyProductPermission, setCompanyProductPermission] = useState<FsaPermission[]>([]);
    const [selectClientRegular, setSelectClientRegular] = useState<CashPayment[]>([]);
    const componentRef = React.createRef();

    const headAccount = findHeadAccount(
        PortfolioDashboardStore.getData(),
        props.headAccountHierarchyId || props.subAccountHierarchyId
    );

    const headAccountCompany = headAccount.Company;

    const onCompanyFsaPermissionsChange = useCallback(() => {
        const isLoading = CompanyFsaPermissionsStore.isLoadingForQuery(headAccountCompany);
        const data = CompanyFsaPermissionsStore.getPayload(headAccountCompany);

        if (isLoading || data == null) {
            return;
        }

        setCompanyProductPermission(data);
    }, [headAccountCompany, setCompanyProductPermission]);

    useSubscribeToStore(CompanyFsaPermissionsStore, onCompanyFsaPermissionsChange);

    React.useEffect(() => {
        if (SubAccountTypeHelper.isLegacyProduct(item.ProductType)) {
            const isLoading = CompanyFsaPermissionsStore.isLoadingForQuery(headAccountCompany);
            const data = CompanyFsaPermissionsStore.getPayload(headAccountCompany);

            if (isLoading) {
                return;
            }

            if (data != null) {
                onCompanyFsaPermissionsChange();
                return;
            }

            CompanyWizardAction.getCompanyFsaPermissionDetail(headAccountCompany);
        }
    }, [headAccountCompany, onCompanyFsaPermissionsChange]);

    React.useEffect(() => {
        if (item.ProductType == SubAccountType.CashIsa) {
            if (!currentYearIsaAllowance && !currentYearIsaAllowanceLoading) {
                setCurrentYearUsaAllowanceLoading(true);
                new IsaAllowanceOverviewClient().get(headAccountHierarchyId, 0).onSuccess((x) => {
                    setCurrentYearIsaAllowance(x);
                    setCurrentYearUsaAllowanceLoading(false);
                });
            }
            if (!lastYearIsaAllowance && !lastYearIsaAllowanceLoading) {
                setLastYearUsaAllowanceLoading(true);
                new IsaAllowanceOverviewClient().get(headAccountHierarchyId, 1).onSuccess((x) => {
                    setLastYearIsaAllowance(x);
                    setLastYearUsaAllowanceLoading(false);
                });
            }
        }
    }, [headAccountHierarchyId]);

    const handleLaunchpadClick = React.useCallback(() => {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {
            context.customerId = customerHierarchyId;
        }
        if (headAccountHierarchyId) {
            context.accountGroupId = headAccountHierarchyId;
        }
        if (subAccountHierarchyId) {
            context.accountId = subAccountHierarchyId;
        }

        (window as any).AppStore.open(context);
    }, [headAccountHierarchyId, subAccountHierarchyId]);

    const { addEvent } = new AdviserSiteTagManager();

    const checkShowPopMsg = (processType: ProcessType): boolean => {
        return WizardLinkRestriction(headAccount, props.subAccountHierarchyId, processType);
    };

    const editRegularLink = (cashEntryId: number) => {
        return StaticUrls.RegularPaymentUrl(
            item.ProductType?.toString(),
            item.ClAccountId,
            headAccountHierarchyId,
            subAccountHierarchyId,
            "edit",
            cashEntryId
        );
    };

    const editWhatIfToolLink = (cashEntryId: number) => {
        return StaticUrls.WhatIfToolUrl(
            item.ProductType?.toString(),
            item.ClAccountId,
            headAccountHierarchyId,
            subAccountHierarchyId,
            cashEntryId,
            false
        );
    };

    const isTrust = headAccount?.InvestorType == InvestorType.Trust;
    let blockTrustTopupAndWithdrawal = false;
    if (isTrust) {
        blockTrustTopupAndWithdrawal = ["loanplan", "discountedgiftplan"].includes(
            (props.trustDetail?.TrustType || "").toLowerCase()
        );
    }
    const disableAllProductByFsa = !companyProductPermission.some(
        (ele) =>
            ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
            ele.IsInclude &&
            ele.IsPermit
    );

    const addGTMEvent = (actionType: string) => {
        addEvent({
            eventParameters: {
                eventCategory: eventCategoryForGTM.summaryTab,
                eventAction: props.buttonTitle == "Quick actions menu" ? "summary table" : "product details",
                eventLabel: `${item.ProductDisplayName}|${actionType}`,
            },
            event: "summarytab_interaction",
        });
    };
    const clickFunc = (show: boolean, actionType: string, onClick?: VoidFunction): VoidFunction => {
        return show
            ? () => setShowErrorMsg(true)
            : onClick
            ? () => {
                  addGTMEvent(actionType);
                  onClick();
              }
            : () => {
                  addGTMEvent(actionType);
              };
    };

    if (item.ProductType == SubAccountType.CashIsa) {
        if (
            (currentYearIsaAllowance?.Expected.Amount > 0 ||
                currentYearIsaAllowance?.Used.Amount > 0 ||
                lastYearIsaAllowance?.Expected.Amount > 0 ||
                lastYearIsaAllowance?.Used.Amount > 0) &&
            JsonDateParser.toDate(currentYearIsaAllowance?.StopIsaCashDate) >= new Date() &&
            checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
        ) {
            const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment);
            textLinks.push({
                title: StaticUrls.SinglePayment,
                url: showErrorMsgSPT
                    ? "javascript:void(0);"
                    : StaticUrls.SinglePaymentUrl(
                          item.ProductType?.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgSPT, StaticUrls.SinglePayment),
            });
            if (regularPaymentsIn) {
                const showErrorMsgEditRegular = checkShowPopMsg(ProcessType.EditRegular);
                textLinks.push({
                    title: StaticUrls.RegularPaymentEdit,
                    url: "javascript:void(0);",
                    clickFunction: clickFunc(showErrorMsgEditRegular, StaticUrls.RegularPaymentEdit, () => {
                        Action.getRegularPaymentCashEntry(
                            item.SubAccountHierarchyId,
                            CashPaymentTypeQuery.Deposit,
                            CashPaymentFrequencyQuery.Regular,
                            (result: CashPayment[]) => {
                                const clientRegularPayment = result.filter(
                                    (cashEntry) =>
                                        (cashEntry.Source == PaymentSource.Employee ||
                                            cashEntry.Source == PaymentSource.NotSpecified) &&
                                        cashEntry.InstructionType == InstructionType.Standing &&
                                        cashEntry.Status == PaymentStatus.Authorised
                                );
                                if (clientRegularPayment.length > 1) {
                                    setSelectClientRegular(clientRegularPayment);
                                } else {
                                    window.location.assign(editRegularLink(clientRegularPayment[0]?.BatchId));
                                }
                            }
                        );
                    }),
                });
            } else {
                const showErrorMsgAddRegular = checkShowPopMsg(ProcessType.AddRegular);
                textLinks.push({
                    title: StaticUrls.RegularPayment,
                    url: showErrorMsgAddRegular
                        ? "javascript:void(0);"
                        : StaticUrls.RegularPaymentUrl(
                              item.ProductType?.toString(),
                              item.ClAccountId,
                              headAccountHierarchyId,
                              subAccountHierarchyId,
                              "add"
                          ),
                    clickFunction: clickFunc(showErrorMsgAddRegular, StaticUrls.RegularPayment),
                });
            }
        }
    }
    // top up wizard
    if (
        [
            SubAccountType.InvestmentAccount,
            SubAccountType.StocksIsa,
            SubAccountType.WrapCash,
            SubAccountType.Npr,
        ].includes(item.ProductType)
    ) {
        const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment);
        const showErrorMsgEditRegular = checkShowPopMsg(
            regularPaymentsIn ? ProcessType.EditRegular : ProcessType.AddRegular
        );
        if (isTrust) {
            if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
                textLinks.push({
                    title: StaticUrls.SinglePayment,
                    url:
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal
                            ? "javascript:void(0);"
                            : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isLegacyProduct(item.ProductType)),
                    clickFunction: clickFunc(showErrorMsgSPT || blockTrustTopupAndWithdrawal, StaticUrls.SinglePayment),
                });
                textLinks.push({
                    title: regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment,
                    url:
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal
                            ? "javascript:void(0);"
                            : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isLegacyProduct(item.ProductType)),
                    clickFunction: clickFunc(
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal,
                        regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment
                    ),
                });
            }
        } else {
            if (checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)) {
                textLinks.push({
                    title: StaticUrls.SinglePayment,
                    url: showErrorMsgSPT
                        ? "javascript:void(0);"
                        : StaticUrls.SinglePaymentUrl(
                              item.ProductType?.toString(),
                              item.ClAccountId,
                              headAccountHierarchyId,
                              subAccountHierarchyId
                          ),
                    clickFunction: clickFunc(showErrorMsgSPT, StaticUrls.SinglePayment),
                });
                if (regularPaymentsIn) {
                    const showErrorMsgEditRegular = checkShowPopMsg(ProcessType.EditRegular);
                    textLinks.push({
                        title: StaticUrls.RegularPaymentEdit,
                        url: "javascript:void(0);",
                        clickFunction: clickFunc(showErrorMsgEditRegular, StaticUrls.RegularPaymentEdit, () => {
                            Action.getRegularPaymentCashEntry(
                                item.SubAccountHierarchyId,
                                CashPaymentTypeQuery.Deposit,
                                CashPaymentFrequencyQuery.Regular,
                                (result: CashPayment[]) => {
                                    const clientRegularPayment = result.filter(
                                        (cashEntry) =>
                                            (cashEntry.Source == PaymentSource.Employee ||
                                                cashEntry.Source == PaymentSource.NotSpecified) &&
                                            cashEntry.InstructionType == InstructionType.Standing &&
                                            cashEntry.Status == PaymentStatus.Authorised
                                    );
                                    if (clientRegularPayment.length > 1) {
                                        setSelectClientRegular(clientRegularPayment);
                                        setMutiPaymentType(ProcessType.EditRegular);
                                    } else {
                                        window.location.assign(editRegularLink(clientRegularPayment[0]?.BatchId));
                                    }
                                }
                            );
                        }),
                    });
                } else {
                    const showErrorMsgAddRegular = checkShowPopMsg(ProcessType.AddRegular);
                    textLinks.push({
                        title: StaticUrls.RegularPayment,
                        url: showErrorMsgAddRegular
                            ? "javascript:void(0);"
                            : StaticUrls.RegularPaymentUrl(
                                  item.ProductType?.toString(),
                                  item.ClAccountId,
                                  headAccountHierarchyId,
                                  subAccountHierarchyId,
                                  "add"
                              ),
                        clickFunction: clickFunc(showErrorMsgAddRegular, StaticUrls.RegularPayment),
                    });
                }
            }
        }
    }
    // buy sell switch
    if (
        [SubAccountType.InvestmentAccount, SubAccountType.StocksIsa, SubAccountType.Npr].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgBuy = checkShowPopMsg(ProcessType.Buy);
        const showErrorMsgSell = checkShowPopMsg(ProcessType.Sell);
        const showErrorMsgSwitch = checkShowPopMsg(ProcessType.Switch);
        if (isTrust) {
            textLinks.push({
                title: StaticUrls.Buy,
                url: showErrorMsgBuy ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
            });
            textLinks.push({
                title: StaticUrls.Sell,
                url: showErrorMsgSell ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
            });
            textLinks.push({
                title: StaticUrls.Switch,
                url: showErrorMsgSwitch ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
            });
        } else {
            textLinks.push({
                title: StaticUrls.Buy,
                url: showErrorMsgBuy
                    ? "javascript:void(0);"
                    : StaticUrls.BuyUrl(
                          item.ProductType?.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
            });

            textLinks.push({
                title: StaticUrls.Sell,
                url: showErrorMsgSell
                    ? "javascript:void(0);"
                    : StaticUrls.SellUrl(
                          item.ProductType?.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
            });

            textLinks.push({
                title: StaticUrls.Switch,
                url: showErrorMsgSwitch
                    ? "javascript:void(0);"
                    : StaticUrls.SwitchUrl(
                          item.ProductType?.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
            });
        }

        if (item.ProductType == SubAccountType.Npr) {
            textLinks.push({
                title: StaticUrls.IncomePaymentOneOff,
                url: StaticUrls.IncomePaymentOneOffUrl(
                    item.ProductType.toString(),
                    item.ClAccountId,
                    headAccountHierarchyId,
                    subAccountHierarchyId
                ),
                clickFunction: clickFunc(false, StaticUrls.IncomePaymentOneOff),
            });
            textLinks.push({
                title: StaticUrls.UpdateLifetimeAllowance,
                url: StaticUrls.UpdateLifetimeAllowanceUrl(headAccountHierarchyId, subAccountHierarchyId),
                clickFunction: clickFunc(false, StaticUrls.UpdateLifetimeAllowance),
            });
        }
    }
    const showErrorMsgWithdrawal = checkShowPopMsg(ProcessType.Withdrawal);
    if (
        [
            SubAccountType.InvestmentAccount,
            SubAccountType.StocksIsa,
            SubAccountType.WrapCash,
            SubAccountType.CashIsa,
        ].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView)
    ) {
        textLinks.push({
            title: StaticUrls.Withdraw,
            url: "javascript:void(0);",
            clickFunction: () => {
                if (showErrorMsgWithdrawal || blockTrustTopupAndWithdrawal) {
                    setShowErrorMsg(true);
                } else if (isWithDrawalRestriction) {
                    props.restrictWithdrawal();
                } else {
                    addGTMEvent(StaticUrls.Withdraw);
                    window.location.assign(StaticUrls.WithdrawUrl(item.ClAccountId));
                }
            },
        });
    }
    if ([SubAccountType.InvestmentAccount, SubAccountType.StocksIsa].includes(item.ProductType)) {
        const showErrorMsgWhatIf = checkShowPopMsg(ProcessType.WhatIf);
        if (checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)) {
            if (!isTrust) {
                textLinks.push({
                    title: StaticUrls.WhatIfTool,
                    url: "javascript:void(0);",
                    clickFunction: clickFunc(showErrorMsgWhatIf, StaticUrls.WhatIfTool, () => {
                        Action.getRegularPaymentCashEntry(
                            item.SubAccountHierarchyId,
                            CashPaymentTypeQuery.Deposit,
                            CashPaymentFrequencyQuery.Regular,
                            (result: CashPayment[]) => {
                                const clientRegularPayment = result.filter(
                                    (cashEntry) =>
                                        (cashEntry.Source == PaymentSource.Employee ||
                                            cashEntry.Source == PaymentSource.NotSpecified) &&
                                        cashEntry.InstructionType == InstructionType.Standing &&
                                        cashEntry.Status == PaymentStatus.Authorised
                                );
                                if (clientRegularPayment.length > 1) {
                                    setSelectClientRegular(clientRegularPayment);
                                    setMutiPaymentType(ProcessType.WhatIf);
                                } else {
                                    window.location.assign(editWhatIfToolLink(clientRegularPayment[0]?.BatchId));
                                }
                            }
                        );
                    }),
                });
            }
            textLinks.push({
                title: StaticUrls.NoChangeTool,
                url: showErrorMsgWhatIf
                    ? "javascript:void(0);"
                    : StaticUrls.NoChangeToolUrl(
                          item.ProductType.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgWhatIf, StaticUrls.NoChangeTool),
            });
        }
    }
    if ([SubAccountType.Sipp, SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType)) {
        const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment);
        if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
            textLinks.push({
                title: StaticUrls.SinglePayment,
                url:
                    showErrorMsgSPT || blockTrustTopupAndWithdrawal || disableAllProductByFsa
                        ? "javascript:void(0);"
                        : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isBond(item.ProductType)),
                clickFunction: clickFunc(
                    showErrorMsgSPT || blockTrustTopupAndWithdrawal || disableAllProductByFsa,
                    StaticUrls.SinglePayment
                ),
            });
        }
    }
    if (item.ProductType == SubAccountType.Sipp) {
        const showErrorMsgRegular = checkShowPopMsg(ProcessType.AddRegular);
        if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
            textLinks.push({
                title: regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment,
                url:
                    showErrorMsgRegular || blockTrustTopupAndWithdrawal || disableAllProductByFsa
                        ? "javascript:void(0);"
                        : StaticUrls.NBEC(item.ClAccountId),
                clickFunction: clickFunc(
                    showErrorMsgRegular || blockTrustTopupAndWithdrawal || disableAllProductByFsa,
                    regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment
                ),
            });
        }
    }
    if (
        [SubAccountType.Sipp, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgBuy = checkShowPopMsg(ProcessType.Buy);
        const showErrorMsgSell = checkShowPopMsg(ProcessType.Sell);

        textLinks.push({
            title: StaticUrls.Buy,
            url: showErrorMsgBuy ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
        });
        textLinks.push({
            title: StaticUrls.Sell,
            url: showErrorMsgSell ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
        });
    }
    if (
        [SubAccountType.Sipp, SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgSwitch = checkShowPopMsg(ProcessType.Switch);
        textLinks.push({
            title: StaticUrls.Switch,
            url: showErrorMsgSwitch ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
        });
    }
    if (
        [SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView)
    ) {
        const showErrorMsgWithdrawal = checkShowPopMsg(ProcessType.Withdrawal);
        textLinks.push({
            title: StaticUrls.Withdraw,
            url: "javascript:void(0);",
            clickFunction: () => {
                if (showErrorMsgWithdrawal || blockTrustTopupAndWithdrawal) {
                    setShowErrorMsg(true);
                } else {
                    addGTMEvent(StaticUrls.Withdraw);
                    props.prohibitedWithdrawal();
                }
            },
        });
    }
    if (isAppStoreEnabled) {
        textLinks.push({ title: StaticUrls.LaunchApps, clickFunction: handleLaunchpadClick });
    }
    if (textLinks.filter((ele) => ele != null).length == 0) {
        return null;
    }

    return (
        <>
            {textLinks?.length > 0 && <TextAndDots textLinks={textLinks} buttonTitle={props.buttonTitle} />}
            {showErrorMsg && (
                <Lightbox
                    show={showErrorMsg}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => setShowErrorMsg(false)}
                    type={LightboxType.Modal}
                    cssWrapper={"is-default-lightbox"}
                >
                    <p>
                        {blockTrustTopupAndWithdrawal
                            ? "This journey is not available for this type of Trust."
                            : disableAllProductByFsa && SubAccountTypeHelper.isLegacyProduct(item.ProductType)
                            ? "FCA Permissions prevents the following action."
                            : "You cannot process this action until the account is active"}
                    </p>
                    <button className="btn primary" onClick={() => setShowErrorMsg(false)}>
                        Ok
                    </button>
                </Lightbox>
            )}
            {checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                <SelectRegularPaymentPop
                    clientRegularPayment={selectClientRegular}
                    onClose={() => {
                        setSelectClientRegular([]);
                    }}
                    onSelect={(id) =>
                        window.location.assign(
                            multiPaymentType == ProcessType.EditRegular ? editRegularLink(id) : editWhatIfToolLink(id)
                        )
                    }
                />
            )}
        </>
    );
};
